import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./ClientsSection.scss";


function ClientsSection3(props) {
  const items = [
    {
      name: "AWS",
      image: "aws_logo.svg",
      width: "150px",
    },
    {
      name: "Google Cloud",
      image: "google_cloud_logo.svg",
      width: "400px",
    },
    {
      name: "Azure",
      image: "azure_logo.svg",
      width: "200px",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-multiline py-2">
          {items.map((item, index) => (
            <div className="column is-narrow has-text-centered" key={index}>
              <div className="ClientsSection__logo">
                <img src={item.image} width={item.width} alt={item.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default ClientsSection3;
